const acesso = '/acesso';
const catterpilar = '/vacinacao';
const relatorioVacinacao = '/relatoriovacinacao';
const relatorioVacinacaoFiltro = '/relatoriovacinacao/filtro';

export const authorization = {    
  credentials: 'include',
  headers: {
    'Accept': 'application/json, text/plain, */*',
    'Authorization': `Bearer ${localStorage.getItem("token")}`,
    'Content-Type': 'application/json',
    'Access-Control-Allow-Origin': '*',
    'xdrogalpkey': '8c4741a4-304c-47c4-a4f3-619007a3218b'
  },
  headersWithoutToken: {
    'Accept': 'application/json, text/plain, */*',
    'Content-Type': 'application/json',
    'Access-Control-Allow-Origin': '*',
    'xdrogalpkey': '8c4741a4-304c-47c4-a4f3-619007a3218b'
  }
};

export const baseUrl = {
  apiAcesso: 'https://apigateway.drogal.com.br/',
  apiConvenio: {
    PROD: 'https://apigateway.drogal.com.br/vacinacao',
    DEV:'http://localhost:44363/caterpillar/ctp-v1'
  }
}

export const addresses = {
  loginCatterpilar: `${catterpilar}/logincaterpillar`,
  login: `${acesso}/login`,
  gravarvacinacao: `/gravarvacinacao`,
  dadosvacina: `/dadosvacina`,
  farmaceuticos: `/farmaceuticos`,
  relatorioVacinacao: `${relatorioVacinacao}`,
  relatorioVacinacaoFiltro: `${relatorioVacinacaoFiltro}`
}
